import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import ComingSoonTooltip from '@/components/ui/custom/dataDisplay/ComingSoonTooltip';
import { MaterialType } from '@/models/Book';
import { MaterialTypeOption } from '@/utils/material/materialTypeOptions';

type MaterialTypeOptionCardProps = {
  option: MaterialTypeOption;
  selected: boolean;
  onSelect: (type: MaterialType) => void;
};

export default function MaterialTypeOptionCard({
  option: { type, Icon, comingSoon },
  selected,
  onSelect,
}: MaterialTypeOptionCardProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.materialsTab.typeSelector.options',
  });
  const handleClick = () => {
    if (!comingSoon) onSelect(type);
  };

  return (
    <ComingSoonTooltip disabled={comingSoon} className="w-full">
      <button
        type="button"
        role="radio"
        aria-checked={selected}
        aria-disabled={comingSoon}
        onClick={handleClick}
        className={twMerge(
          'card card-border rounded-2xl w-full h-full items-start gap-4 p-4 text-left bg-base-100 border-base-300 transition-colors',
          selected && 'border-primary ring-1 ring-primary bg-primary-content',
          !comingSoon && 'hover:border-primary',
        )}
      >
        <span
          className={twMerge(
            'rounded-lg bg-base-200 p-2.5',
            selected && 'bg-base-100',
          )}
        >
          <Icon className="size-5" />
        </span>
        <span className="flex flex-col gap-1">
          <span className="font-semibold text-base-content text-base leading-7">
            {t(`${type}.name`)}
          </span>
          <span className="text-sm text-base-content/70">
            {t(`${type}.description`)}
          </span>
        </span>
      </button>
    </ComingSoonTooltip>
  );
}
